<script lang="ts">
	import { onMount, onDestroy } from "svelte";
	import L from "leaflet";
	import "leaflet/dist/leaflet.css";
	import { bbox } from "@turf/bbox";
	import gRC from "./extras/getRandomCoords.svelte";

	interface mapprops {
		g: string;
		wireident: string;
	}
	let { g, wireident }: mapprops = $props();

	let mapContainer: HTMLDivElement;
	let map: L.Map | null = null;

	onMount(() => {
		// Parse GeoJSON if it's a string
		const geojson = typeof g === "string" ? JSON.parse(g) : g;

		// Get bounds from geometry
		const [minX, minY, maxX, maxY] = bbox(geojson);
		const bounds: L.LatLngBoundsExpression = [
			[minY, minX],
			[maxY, maxX]
		];

		// Start at random location like CardMaplibre
		const [lon, lat] = gRC();

		map = L.map(mapContainer, {
			zoomControl: false,
			attributionControl: false,
			dragging: false,
			scrollWheelZoom: false,
			doubleClickZoom: false,
			boxZoom: false,
			keyboard: false,
			touchZoom: false,
			center: [lat, lon],
			zoom: 2
		});

		// CartoDB Positron (similar to what was used before)
		L.tileLayer(
			"https://{s}.basemaps.cartocdn.com/light_all/{z}/{x}/{y}{r}.png",
			{ maxZoom: 20 }
		).addTo(map);

		// Add GeoJSON with livewire orange styling
		L.geoJSON(geojson, {
			style: {
				color: "#ff3e00",
				weight: 2,
				dashArray: "10, 2",
				fillOpacity: 0
			}
		}).addTo(map);

		// Fly to bounds after a random delay (staggered effect)
		const delay = Math.random() * 165;
		setTimeout(() => {
			map?.flyToBounds(bounds, { padding: [25, 25], duration: 1.5 });
		}, delay);
	});

	onDestroy(() => {
		if (map) {
			map.remove();
			map = null;
		}
	});
</script>

<div bind:this={mapContainer} class="card-leaflet-map" style="height: 100%;"></div>

<style>
	.card-leaflet-map {
		background-color: #e8e8e8;
	}
</style>
